// Entry point for the build script in your package.json
import Rails from "@rails/ujs"
import "@hotwired/turbo-rails"
import "./controllers"
import * as bootstrap from "bootstrap"
import "./jquery"
import "./react/token"
import "./sweet_alert";

import 'bootstrap-table/dist/bootstrap-table.js';
import 'bootstrap-table/dist/locale/bootstrap-table-es-CL.js';

import "chartkick/chart.js"
import 'chart.js';
import 'chartjs-gauge';

Rails.start()
Turbo.config.forms.mode = "off"

// ROUTES
import * as Routes from './routes';
window.Routes = Routes;

//AdminLTE
import 'admin-lte/dist/js/adminlte.min.js'

// I18n
import { I18n } from "i18n-js";
import translations from "./locales.json";

const i18n = new I18n(translations);
i18n.defaultLocale = "es";
i18n.locale = "es";
window.I18n = i18n;
//

// Lodash
import _ from "lodash-es";
window._ = _;
//

// Bootstrap
window.bootstrap = bootstrap;
//

// Moment
window.moment = require('moment');
//

import "./react"

// Cocoon
import "@nathanvda/cocoon"

// Gantt Recurrence
import "./gantt_recurrence/index.js";

window.swal = require('sweetalert2')
import swal from 'sweetalert2';

window.swalWithBootstrap = swal.mixin({
  customClass: {
    confirmButton: 'btn btn-success ml-3',
    cancelButton: 'btn btn-secondary'
  },
  showCancelButton: true,
  cancelButtonText: "<i class='fa fa-thumbs-down'></i> Cancelar",
  confirmButtonText: "<i class='fa fa-thumbs-up'></i> Confirmar",
  reverseButtons: true,
  buttonsStyling: false
});

window.swalToastBootstrap = swal.mixin({
  toast: true,
  position: "bottom-end",
  showConfirmButton: false,
  timer: 3000,
  timerProgressBar: true,
  didOpen: (toast) => {
    toast.onmouseenter = swal.stopTimer;
    toast.onmouseleave = swal.resumeTimer;
  }
});


(function () {
  function initializeBootstrapTables() {
    const tables = document.querySelectorAll('[data-toggle="table"]');
    tables.forEach(table => {
      $(table).bootstrapTable();
    });
  }

  function initializeBootstrapTooltips() {
    let tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'))
    tooltipTriggerList.map(function (tooltipTriggerEl) {
      return new bootstrap.Tooltip(tooltipTriggerEl)
    })
  }

  initializeBootstrapTables();
  initializeBootstrapTooltips();

  document.addEventListener('turbo:load', () => {
    initializeBootstrapTables();
    initializeBootstrapTooltips();

    window.zEACLoaded = undefined;
  });

  document.addEventListener('turbo:render', () => {
    initializeBootstrapTables();
    initializeBootstrapTooltips();

    window.zEACLoaded = undefined;
  });
})();

// TODO: replace for a stimulus controller
$(function () {
  window.copyText = (target) => {
    const text = target.getAttribute('data-copy-text');
    const textElement = document.getElementById("copy-url");

    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(text).then(() => {
        togleTooltip(target, 'Copiado!', 'Copiar');
      }).catch(() => {
        console.error('Failed to copy using clipboard API.');
        fallbackCopy(text, target);
      });
    } else {
      fallbackCopy(text, target);
    }
    highlightText(textElement);
  }

  function fallbackCopy(text, target) {
    var textArea = document.createElement('textarea');
    textArea.value = text;
    document.body.append(textArea);
    textArea.select();
    document.execCommand("copy");
    document.body.removeChild(textArea);
    togleTooltip(target, 'Copiado!', 'Copiar');
  }

  function togleTooltip(target, successTitle, originalTitle) {
    const tooltip = bootstrap.Tooltip.getInstance(target) || new bootstrap.Tooltip(target);

    target.setAttribute('title', successTitle);
    tooltip._fixTitle();
    tooltip.show();

    setTimeout(() => {
      target.setAttribute('title', originalTitle);
      tooltip._fixTitle();
      tooltip.hide();
    }, 1000);
  }

  function highlightText(element) {
    const range = document.createRange();
    range.selectNodeContents(element);

    const selection = window.getSelection();
    selection.removeAllRanges();
    selection.addRange(range);
  }
}())
